module.exports = __webpack_public_path__ + "img/banner_effect.6f708910.jpg";